import { render } from "./UserPageMenu.vue?vue&type=template&id=1743063b"
import script from "./UserPageMenu.vue?vue&type=script&lang=js"
export * from "./UserPageMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__